import { MeasurementUnitModel, type MeasurementUnit } from '@/http/models/PosCatalog'

import { Badge } from '@/components/ui/badge'

import { ResourcePage } from '@/components/features/pos/ResourcePage'

const MeasurementUnits = () => (
  <ResourcePage<MeasurementUnit>
    title="Measurement units"
    description="Units products are sold in, such as pcs, kg or m."
    noun="unit"
    api={MeasurementUnitModel}
    permissions={{ create: 'measurement_units:create', update: 'measurement_units:update', delete: 'measurement_units:delete' }}
    searchPlaceholder="Search by title"
    deleteDescription="This deletes the unit permanently."
    columns={[
      { label: 'Title', render: (u) => <span className="font-medium text-ink">{u.title}</span> },
      { label: 'Description', render: (u) => u.description || '—', className: 'hidden md:table-cell' },
      { label: 'Status', render: (u) => <Badge tone={u.status === 'active' ? 'success' : 'soft'}>{u.status === 'active' ? 'Active' : 'Inactive'}</Badge> },
    ]}
    fields={[
      { name: 'title', label: 'Title', type: 'text', required: true, placeholder: 'kg' },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'status', label: 'Active', type: 'status' },
    ]}
    toForm={(u) => ({ title: u?.title ?? '', description: u?.description ?? '', status: (u?.status ?? 'active') === 'active' })}
  />
)

export default MeasurementUnits
